import { 
  CalculatorIcon, 
  BookOpenIcon, 
  FolderIcon, 
  CalendarIcon, 
  CreditCard,
  FileBarChartIcon
} from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * Accounting & Finance Navigation Sections
 * Two sections: Accounting and Reports
 */
export const reportsFinanceSections: NavigationSectionConfig[] = [
  // Accounting section
  {
    id: 'accounting-section',
    label: 'Accounting',
    topNavId: 'accounting-finance',
    items: [
      {
        id: 'ledger-dashboard',
        label: 'Ledger',
        path: '/ledger',
        icon: <CalculatorIcon size={18} />,
        permissions: ['nav:ledger']
      },
      {
        id: 'journals',
        label: 'Journal',
        path: '/ledger/journals',
        icon: <BookOpenIcon size={18} />,
        permissions: ['nav:journals']
      },
      {
        id: 'chart-of-accounts',
        label: 'Chart of Accounts',
        path: '/ledger/accounts',
        icon: <FolderIcon size={18} />,
        permissions: ['nav:chart-of-accounts']
      },
      {
        id: 'periods',
        label: 'Periods',
        path: '/ledger/periods',
        icon: <CalendarIcon size={18} />,
        permissions: ['nav:periods']
      },
      {
        id: 'payments',
        label: 'Payment Management',
        path: '/admin/payments',
        icon: <CreditCard size={18} />,
        permissions: ['nav:payment-management']
      }
    ]
  },
  // Reports section
  {
    id: 'reports-section',
    label: 'Reports',
    topNavId: 'accounting-finance',
    items: [
      {
        id: 'ledger-reports',
        label: 'Ledger Reports',
        path: '/ledger/reports',
        icon: <FileBarChartIcon size={18} />,
        permissions: ['nav:ledger-reports']
      }
    ]
  }
];

